import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router';
import SettingsLink from './SettingsLink';

interface SubscriptionSettingLinkProps {}

const SubscriptionSettingLink: FunctionComponent<SubscriptionSettingLinkProps> = () => {
  const navigate = useNavigate();

  const onClick = () => {
    window.open(`https://daasportal.app/files/DaaS-Portal-Fee-Structure-Pricing.pdf`);
  };

  return <SettingsLink name="Subscriptions" onClick={onClick} />;
};

export default SubscriptionSettingLink;
